import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function SeoHead({
  title,
  description,
  canonicalUrl,
  ogImage = 'https://assets.auxodev.dk/assets/e1e86ea9-8aac-4deb-bab2-e96b6ba9dd16/kromix-logo-hvid.png',
}) {
  // Ensure "KROMIX A/S" appears in title
  let fullTitle = title || 'KROMIX A/S';
  if (!fullTitle.includes('KROMIX')) {
    fullTitle = `${fullTitle} - KROMIX A/S`;
  }

  const defaultDesc =
    'KROMIX A/S producerer kvalitetsfoder til hunde og katte. Nærende foder fra nøje udvalgte råvarer for optimal sundhed, trivsel og vitalitet.';

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description || defaultDesc} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || defaultDesc} />
      <meta property="og:type" content="website" />
      {ogImage && <meta property="og:image" content={ogImage} />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
    </Helmet>
  );
}
